import React from "react";
import { Redirect, Route } from "react-router";
import useViewer from "../hooks/useViewer";

import { Layout } from "../components/wombat-ui";
import ErrorBoundaryScreen from "../screens/ErrorBoundaryScreen";
import useTokenLogin from "../hooks/useTokenLogin";

function PrivateRoute({
  component: Component,
  withLayout = true,
  ...restProps
}) {
  const viewer = useViewer();
  const { checked } = useTokenLogin();

  if (!checked) {
    return null;
  }

  return (
    <>
      <Route
        {...restProps}
        render={(props) => {
          return viewer ? (
            withLayout ? (
              <Layout>
                <ErrorBoundaryScreen type="UnexpectedError">
                  <Component {...props} />
                </ErrorBoundaryScreen>
              </Layout>
            ) : (
              <ErrorBoundaryScreen type="UnexpectedError">
                <Component {...props} />
              </ErrorBoundaryScreen>
            )
          ) : (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }}
      />
    </>
  );
}

export default PrivateRoute;
